// @ts-nocheck -- Transitional typing for a legacy JavaScript module.
import React from "react";
import { formatUtcDate } from "@/utils/common.utils";
import { daysBetweenIso } from "@/utils/deals.utils";

export const dash = <span className="text-dash-faint">—</span>;

/**
 * SpecRow — one label/value line inside a Contract details card.
 *
 * The value carries free text an agent typed (kickout terms, home-sale
 * address), so it needs `min-w-0` to opt out of the flex default of
 * min-width:auto — without it the <dd> refuses to shrink below its intrinsic
 * width and a long clause pushes out past the card. `break-words` then splits
 * any single token longer than the column.
 */
export function SpecRow({ k, v, testid }) {
  return (
    <div
      className="flex items-baseline justify-between gap-4 border-b border-dash-borderSoft py-2.5 last:border-b-0"
      data-testid={testid}
    >
      <dt className="shrink-0 text-[13px] text-dash-muted">{k}</dt>
      <dd className="min-w-0 break-words text-right text-[13px] font-medium text-dash-ink">{v}</dd>
    </div>
  );
}

/**
 * DueDiligenceValue — "when does DD end" plus a relative-days note, so the
 * reader sees both the date AND where they are in the window.
 */
export function DueDiligenceValue({ iso }) {
  if (!iso) return dash;
  const days = daysBetweenIso(new Date().toISOString(), iso);
  const dateStr = formatUtcDate(iso, { year: "numeric" }, "—");
  let chip = null;
  if (typeof days === "number") {
    if (days > 0) chip = <span className="ml-2 text-xs font-normal text-dash-greenDeep">in {days} {days === 1 ? "day" : "days"}</span>;
    else if (days === 0) chip = <span className="ml-2 text-xs font-normal text-dash-rust">today</span>;
    else chip = <span className="ml-2 text-xs font-normal text-dash-muted">ended</span>;
  }
  return <>{dateStr}{chip}</>;
}
